import React, { useContext, useEffect, useState } from "react";
import useFetch from "../../Hooks/useFetch";
import { useNavigate, useParams } from "react-router-dom";
import { userContext } from "../../Contexts/userContext";
import { coachesURL } from "../../Hooks/URL";
import AddCoach from "../../Template/Home/Coaches/AddCoach/AddCoach";
import useFetchWhen from "../../Hooks/useFetchWhen";

function AddCoachPage() {
  const { contextData, setContextData } = useContext(userContext);
  const navigate = useNavigate();
  const params = useParams();

  const [coach, setCoach] = useState("");
  const {
    data: coachData,
    loading: coachLoading,
    error: coachError,
  } = useFetchWhen(`${coachesURL}/${params?.id}`, params?.id);

  useEffect(() => {
    if (coachData?.data) setCoach(coachData?.data);
  }, [coachData]);

  return <AddCoach url={coachesURL} editId={params?.id} coach={coach} />;
}

export default AddCoachPage;
